module.exports = __webpack_public_path__ + "img/database.c82dbe43.svg";